export default {
    SET_GRAPH_FROM_CASE(state, data) {
        state.graphFromCase = data
    },
    SWITCH_MY_CASES_VISIBILITY_MENU(state) {
        state.myCasesVisibilityMenuSwitcher = !state.myCasesVisibilityMenuSwitcher
    },
    SET_MY_CASES_VISIBILITY_MENU(state, value) {
        state.myCasesVisibilityMenuSwitcher = value
    },
    SET_CASES_ACTIVE_TAB(state, tab) {
        state.casesActiveTab = tab
    },
    SET_CASES_TIME_FILTER(state, filter) {
        state.casesTimeFilter = filter
    },
    SET_CASES_LOADING(state, isLoading) {
        state.casesLoading = isLoading
    },
    SET_ACTIVE_BLOCKCHAIN(state, payload) {
        state.activeBlockchain = payload
    },
}
